"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _Modal = _interopRequireDefault(require("@concur/nui-widgets/lib/Modal/Modal"));
var _Icon = _interopRequireDefault(require("@concur/nui-widgets/lib/Icon/Icon"));
var _Button = _interopRequireDefault(require("@concur/nui-widgets/lib/Buttons/Button"));
var _listingModule = require("./listingModule");
var _utils = require("../utils");
var AnalyticsModule = _interopRequireWildcard(require("../analytics/modules/AnalyticsModule"));
var _analytics = require("../constants/analytics");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var UnenrollModal = function UnenrollModal(_ref) {
  var isUnenrollModalOpen = _ref.isUnenrollModalOpen,
    toggle = _ref.toggle,
    modalNames = _ref.modalNames,
    unenroll = _ref.unenroll,
    listingId = _ref.listingId,
    companyUUID = _ref.companyUUID,
    v1ListingId = _ref.v1ListingId,
    listingData = _ref.listingData,
    trackButtonClick = _ref.trackButtonClick,
    formatter = _ref.formatter;
  var listingName;
  if (listingData[listingId] !== undefined && listingData[listingId].data !== undefined) {
    listingName = listingData[listingId].data.core ? listingData[listingId].data.core.listingName : listingData[v1ListingId].data.core.listingName;
  } else {
    listingName = listingData[v1ListingId].data.core ? listingData[v1ListingId].data.core.listingName : listingData[listingId].data.core.listingName;
  }
  var toggleThisModal = function toggleThisModal() {
    trackButtonClick({
      elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.modal.unenroll, _analytics.button.x],
      dimensions: {
        listingId: listingId,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
    toggle(modalNames.unenroll);
  };
  if (!(0, _utils.canUseDOM)()) {
    return /*#__PURE__*/_react.default.createElement("span", null, "Javascript is Required to Unenroll");
  }
  var handleUnenroll = function handleUnenroll() {
    toggleThisModal();
    return unenroll(listingId, v1ListingId);
  };
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    show: isUnenrollModalOpen,
    onHide: toggleThisModal,
    "aria-label": formatter.formattedMessage({
      id: 'UnenrollModalLabel'
    }),
    size: "md",
    modalContainerClassName: "modal-container"
  }, /*#__PURE__*/_react.default.createElement(_Modal.default.Header, {
    closeLabel: formatter.formattedMessage({
      id: 'Close'
    }),
    closeButton: "true",
    onHide: toggleThisModal
  }, /*#__PURE__*/_react.default.createElement(_Modal.default.Title, {
    headingLevel: "3"
  }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "Confirmation"
  }))), /*#__PURE__*/_react.default.createElement(_Modal.default.Body, {
    className: "centered-modal-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-1"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    iconName: "messaging-warning",
    size: "lg"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-11"
  }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "UnenrollAreYouSure"
  }))), /*#__PURE__*/_react.default.createElement(_Modal.default.Footer, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "pull-right",
    onClick: handleUnenroll
  }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "Yes"
  })), /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "pull-right",
    onClick: toggleThisModal
  }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "No"
  }))));
};
var mapStateToUnenrollProps = function mapStateToUnenrollProps(state) {
  return {
    isUnenrollModalOpen: state.listing.isUnenrollModalOpen,
    modalNames: state.listing.modalNames,
    userId: state.userPrefs.userId,
    options: state.listing.modalOptions,
    listingData: state.listing,
    companyUUID: state.userPrefs.companyUUID
  };
};
UnenrollModal.propTypes = {
  formatter: _propTypes.default.object,
  isUnenrollModalOpen: _propTypes.default.bool.isRequired,
  modalNames: _propTypes.default.object.isRequired,
  unenroll: _propTypes.default.func.isRequired,
  toggle: _propTypes.default.func.isRequired,
  listingId: _propTypes.default.string,
  v1ListingId: _propTypes.default.string,
  listingData: _propTypes.default.object,
  companyUUID: _propTypes.default.string,
  trackButtonClick: _propTypes.default.func
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToUnenrollProps, {
  toggle: _listingModule.toggleModal,
  unenroll: _listingModule.disconnectListing,
  trackButtonClick: AnalyticsModule.buttonClickDispatch
})((0, _nuiIntlRuntime.withFormatter)(UnenrollModal));